import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import SingleCard from "../../layouts/content/SingleCard/SingleCard";
import ContentLoadingBOS from "../../components/ContentLoadingBos";
import * as AppConfig from "logic/GlobalAppConfig";
import LoginHeader from "./LoginHeader";

import Login from "components/User/Login";
import LoginIntegratedSecurity from "components/User/LoginIntegratedSecurity";
import RegisterNewUser from "components/User/RegisterNewUser";
import LoginEmailRequest from "components/User/LoginEmailRequest";
import RegisterGlobalUser from "components/User/RegisterGlobalUser";
import ResetPassword from "components/User/ResetPassword";
import TokenLogin from "components/User/TokenLogin";
import VerifyUser from "components/User/VerifyUser";

// Externals
import compose from "recompose/compose";

// Component styles
import classes from "./LoginPage.module.scss";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appStateActions from "redux/actions/appStateActions";

export const LOGINTYPE_LOGIN = "LOGINTYPE_LOGIN";
export const LOGINTYPE_INTEGRATEDSECURITY = "LOGINTYPE_INTEGRATEDSECURITY";
export const LOGINTYPE_TOKENLOGIN = "LOGINTYPE_TOKENLOGIN";
export const LOGINTYPE_REGISTER_NEWUSER = "LOGINTYPE_REGISTER_NEWUSER";
export const LOGINTYPE_REQUEST_EMAIL = "LOGINTYPE_REQUEST_EMAIL";
export const LOGINTYPE_REGISTER_GLOBALUSER = "LOGINTYPE_REGISTER_GLOBALUSER";
export const LOGINTYPE_RESET_PASSWORD = "LOGINTYPE_RESET_PASSWORD";
export const LOGINTYPE_VERIFY_USER = "LOGINTYPE_VERIFY_USER";

const FALLBACK_DESTINATION_URI = "/launchpad";

function LoginPage(props) {
  const { location } = props;
  const destinationUrl = (location && location.state && location.state.from && location.state.from.pathname);
  const searchParams = (location && location.search);
  
  //console.log("searchParams", searchParams);
  let params = new URLSearchParams(searchParams);
  const loginToken = params.get("logintoken");
  const verifyToken = params.get("verifytoken");

  let loginIS = AppConfig.getUseIntegratedSecurity();

  const [loginType, setLoginType] = useState(loginToken ? LOGINTYPE_TOKENLOGIN : (verifyToken ? LOGINTYPE_VERIFY_USER : (loginIS ? LOGINTYPE_INTEGRATEDSECURITY : LOGINTYPE_LOGIN)));
  const [errorMessage, setErrorMessage] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const handleChangeLoginType = (type) => {
    setLoginType(type);
  }

  const goto = (targetUri) => {
    let uri = normalizeBosUrl(targetUri);
    props.history.replace(uri);
  }

  const normalizeBosUrl = (uri) => {
    //ensure ":" is "/"
    uri = uri.split(":").join("/")
    //ensure leading "/"
    if (!uri.startsWith("/")) uri = "/" + uri;

    return uri;
  }

  const handleSuccess = (type, newStartUri, message, enableLaunchpad = true) => {
    props.appStateActions.disableLaunchpad(!enableLaunchpad);

    switch (type) {
      case LOGINTYPE_LOGIN:
      case LOGINTYPE_INTEGRATEDSECURITY:
      case LOGINTYPE_TOKENLOGIN:
      case LOGINTYPE_REGISTER_NEWUSER:
      case LOGINTYPE_REGISTER_GLOBALUSER:
        goto(newStartUri || FALLBACK_DESTINATION_URI);
        break;
      case LOGINTYPE_REQUEST_EMAIL:
      case LOGINTYPE_RESET_PASSWORD:
      case LOGINTYPE_VERIFY_USER:
        setSuccessMessage(message);
        setErrorMessage();
        break;
      default:
        console.error("Unknown LoginType: ", type);
        break;
    }
  }

  const handleError = (error) => {
    setErrorMessage(error);
    setSuccessMessage();
  }

  const handleCleanMessages = () => {
    setErrorMessage();
    setSuccessMessage();
  }

  const handleSetLoading = (isLoading) => {
    setIsLoading(isLoading);
  }

  const handleGoBack = () => {
    setLoginType(LOGINTYPE_LOGIN);
  }

  const renderLoginType = () => {
    switch (loginType) {
      case LOGINTYPE_LOGIN:
        return <Login targetUri={destinationUrl} changeLoginType={handleChangeLoginType} actionSuccessfull={handleSuccess} actionError={handleError} cleanMessages={handleCleanMessages} setIsLoading={handleSetLoading} isLoading={isLoading} {...props}></Login>;
      case LOGINTYPE_INTEGRATEDSECURITY:
        return <LoginIntegratedSecurity targetUri={destinationUrl} changeLoginType={handleChangeLoginType} actionSuccessfull={handleSuccess} actionError={handleError} cleanMessages={handleCleanMessages} setIsLoading={handleSetLoading} isLoading={isLoading} {...props}></LoginIntegratedSecurity>;
      case LOGINTYPE_TOKENLOGIN:
        return <TokenLogin targetUri={destinationUrl} changeLoginType={handleChangeLoginType} actionSuccessfull={handleSuccess} actionError={handleError} cleanMessages={handleCleanMessages} setIsLoading={handleSetLoading} isLoading={isLoading} loginToken={loginToken} {...props}></TokenLogin>;
      case LOGINTYPE_REGISTER_NEWUSER:
        return <RegisterNewUser targetUri={destinationUrl} changeLoginType={handleChangeLoginType} actionSuccessfull={handleSuccess} actionError={handleError} cleanMessages={handleCleanMessages} setIsLoading={handleSetLoading} isLoading={isLoading} {...props} ></RegisterNewUser>;
      case LOGINTYPE_REQUEST_EMAIL:
        return <LoginEmailRequest targetUri={destinationUrl} changeLoginType={handleChangeLoginType} actionSuccessfull={handleSuccess} actionError={handleError} cleanMessages={handleCleanMessages} setIsLoading={handleSetLoading} isLoading={isLoading} {...props}></LoginEmailRequest>
      case LOGINTYPE_REGISTER_GLOBALUSER:
        return <RegisterGlobalUser targetUri={destinationUrl} changeLoginType={handleChangeLoginType} actionSuccessfull={handleSuccess} actionError={handleError} cleanMessages={handleCleanMessages} setIsLoading={handleSetLoading} isLoading={isLoading} {...props}></RegisterGlobalUser>
      case LOGINTYPE_RESET_PASSWORD:
        return <ResetPassword changeLoginType={handleChangeLoginType} actionSuccessfull={handleSuccess} actionError={handleError} cleanMessages={handleCleanMessages} setIsLoading={handleSetLoading} isLoading={isLoading} {...props}></ResetPassword>
      case LOGINTYPE_VERIFY_USER:
        return <VerifyUser changeLoginType={handleChangeLoginType} actionSuccessfull={handleSuccess} actionError={handleError} cleanMessages={handleCleanMessages} setIsLoading={handleSetLoading} isLoading={isLoading} verifyToken={verifyToken} {...props}></VerifyUser>
      default:
        console.error("Unknown LoginType: ", loginType);
        return <React.Fragment />
    }
  }

  return (
    <React.Fragment>
      <LoginHeader />
      <SingleCard onBackClicked={handleGoBack} showBackButton={loginType !== LOGINTYPE_LOGIN} >
        {renderLoginType()}
      </SingleCard>
      <div className={classes.result}>
        {isLoading ? <ContentLoadingBOS /> : null}
        {errorMessage ? <div className={classes.errorMessage}>{errorMessage}</div> : null}
        {successMessage ? <div className={classes.successMessage}>{successMessage}</div> : null}
      </div>
    </React.Fragment>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    appStateActions: bindActionCreators(appStateActions, dispatch)
  };
}

export default compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  )
)(LoginPage);

